export default "__VITE_ASSET__mah_TgEN__"